
<div class="customer_list">
    <div class="table_container">
        <table [dataSource]="dataSource" mat-table>
            <form [formGroup]="searchForm">
            <!-- actions Column -->
            <ng-container matColumnDef="actions">
                <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                    <div class="field_sec">
                        <div class="search" (click)="searchData()">
                            <mat-icon>search</mat-icon>
                        </div>
                    </div>
                    <h3>
                        Actions
                    </h3>
    
                </th>
                <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                    <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                        (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                        <button mat-menu-item (click)="handleEditTechnician(row?.technicianId)">
                          <span>Edit</span>
                      </button>
    
                      <button mat-menu-item (click)="handleDeleteTechnician(row?.technicianId)">
                        <span>Delete</span>
                    </button>
                    </mat-menu>
               
                </td>
            </ng-container>
            
            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef >
                    <div class="field_sec">
                        <input type="text" placeholder="First Name" formControlName="firstName"/>  
                    </div>
                    <h3 mat-sort-header>
                        First Name
                    </h3>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.firstName}}
                </td>
            </ng-container>
    
            
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef >
                    <div class="field_sec">
                        <input type="text" placeholder="Last Name" formControlName="lastName"/>  
                    </div>
                    <h3 mat-sort-header>
                        Last Name
                    </h3>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.lastName}}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="companyName">
                <th mat-header-cell *matHeaderCellDef >
                    <div class="field_sec">
                        <input type="text" placeholder="Company Name" formControlName="companyName"/>  
                    </div>
                    <h3 mat-sort-header>
                        Company Name
                    </h3>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.companyDetail?.companyName}}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="workOrderEmailAddress">
                <th mat-header-cell *matHeaderCellDef >
                    <div class="field_sec">
                        <input type="text" placeholder="Work Order Email Address" formControlName="workOrderEmailAddress"/>  
                    </div>
                    <h3 mat-sort-header>
                        Work Order Email Address
                    </h3>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.workOrderEmailAddress}}
                </td>
            </ng-container>
            <ng-container matColumnDef="workOrderPhoneNumber">
                <th mat-header-cell *matHeaderCellDef >
                    <div class="field_sec">
                        <input type="text" placeholder="Work Order Phone No." formControlName="workOrderPhoneNumber" (keypress)="apiService.allowNumbers($event)"/>  
                    </div>
                    <h3 mat-sort-header>
                        Work Order Phone No.
                    </h3>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.workOrderPhoneNumber  | mask: '(000) 000-0000'}}
                </td>
            </ng-container>
    
            <ng-container matColumnDef="rating">
                <th mat-header-cell *matHeaderCellDef >
                    <div class="field_sec" >
                        <input type="text" placeholder="Ratting" style="visibility: hidden;"/>  
                    </div>
                    <h3 mat-sort-header>
                        Rating
                    </h3>
                    
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element?.rating}}
                </td>
            </ng-container>
            
            <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
            <tr *matRowDef="let row; columns: visibleColumns"
                class="clickable route-animations-elements" mat-row>
            </tr>
        </form>
        </table>
    </div>
    
    <div
      *ngIf="itemList?.length === 0"
      style="padding: 10px 0; text-align: center"
    >
      No data found.
    </div>
    
</div>

